<div class="card">
    <div class="card-header">
        <strong>Parametros do Web Crawler</strong>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-lg-9">
                <div class="input-group">
                    <input type="text" class="form-control" #dp1="bsDatepicker" bsDatepicker [(bsValue)]="bsDateIni"
                        [bsConfig]="bsConfig" placeholder="Selecione data inicial">
                    <small class="text-muted my-auto">|- até -|</small>
                    <input type="text" class="form-control" #dp2="bsDatepicker" bsDatepicker [(bsValue)]="bsDateFim"
                        [bsConfig]="bsConfig" placeholder="Selecione data final">
                </div>
            </div>
            <div class="col-lg-3">
                <button type="button" class="btn btn-secondary" tooltip="Localizar por data" (click)="getLog()">
                    <i class="fas fa-search"></i>
                </button>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-lg-12">
                <div style="overflow-x: auto">
                    <table class="table table-bordered table-striped table-sm">
                        <thead>
                            <tr>
                                <th>Data</th>
                                <th>Log</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor='let log of LogList'>
                                <td>{{log.data | date :'dd/MM/yyyy HH:mm'}}</td>
                                <td>{{log.logInfo}}</td> 
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>